import { render, staticRenderFns } from "./tipsDialog.vue?vue&type=template&id=71768c7b&scoped=true"
import script from "./tipsDialog.vue?vue&type=script&lang=js"
export * from "./tipsDialog.vue?vue&type=script&lang=js"
import style0 from "./tipsDialog.vue?vue&type=style&index=0&id=71768c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71768c7b",
  null
  
)

export default component.exports